// _neu_generated_code__dont_modify_directly_
/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
//CORE_REFERENCE_IMPORTS
//append_imports_start

import { AfterViewInit, Component, Injector, ViewChild } from '@angular/core'; //_splitter_
import { Router } from '@angular/router'; //_splitter_
import { SDPageCommonService } from 'app/n-services/sd-page-common.service'; //_splitter_
import { SDBaseService } from 'app/n-services/SDBaseService'; //_splitter_
import { NeuServiceInvokerService } from 'app/n-services/service-caller.service'; //_splitter_
import { DataService } from 'app/sd-services/DataService'; //_splitter_
//append_imports_end

@Component({
  selector: 'bh-processLog',
  templateUrl: './processLog.template.html',
  providers: [
    //appendnew_element_providers
  ],
})
export class processLogComponent implements AfterViewInit {
  @ViewChild('logComponent')
  public logComponent: any = null;
  page: any = { dep: {} };
  constructor(
    private __page_injector__: Injector,
    private sdService: SDBaseService,
    public __serviceInvoker__: NeuServiceInvokerService
  ) {
    this.__page_injector__.get(SDPageCommonService).addPageDefaults(this.page);
    this.registerListeners();
    //appendnew_element_inject
  }

  ngOnInit() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    {
      this.sd_h2GU4XQrEYnkoSUr(bh);
    }
  }

  private registerListeners() {
    let bh = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);

    //append_listeners
  }

  sd_h2GU4XQrEYnkoSUr(bh) {
    try {
      bh = this.sd_giOYiOe7rFoMlIPA(bh);
      //appendnew_next_sd_h2GU4XQrEYnkoSUr
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_h2GU4XQrEYnkoSUr');
    }
  }

  runSteps(...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = {};
      bh.local = {};
      bh = this.sd_BT8JjszJYtpBWyed(bh);
      //appendnew_next_runSteps
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_Hxyv92YGWejGNX6X');
    }
  }

  getStepStatus(index: any = undefined, ...others) {
    let bh: any = {};
    try {
      bh = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh.input = { index };
      bh.local = { className: undefined };
      bh = this.sd_POZQMCLgfnsMV06s(bh);
      //appendnew_next_getStepStatus
      return bh.local.className;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_MlNyGTUucKRu6GBd');
    }
  }
  ngAfterViewInit() {
    try {
      var bh: any = this.__page_injector__
        .get(SDPageCommonService)
        .constructFlowObject(this);
      bh = this.sd_BGINIFTw2vJCjFsA(bh);
      //appendnew_next_ngAfterViewInit
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_yLkSS9ehlzV5L45p');
    }
  }

  //appendnew_flow_processLogComponent_start

  sd_giOYiOe7rFoMlIPA(bh) {
    try {
      bh = this.sd_0phqgyaL0xAdXHOi(bh);
      //appendnew_next_sd_giOYiOe7rFoMlIPA
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_giOYiOe7rFoMlIPA');
    }
  }

  sd_0phqgyaL0xAdXHOi(bh) {
    try {
      const DataServiceInstance: DataService =
        this.__page_injector__.get(DataService);
      this.page.fetchRes = DataServiceInstance['fetchRes'];
      bh = this.sd_ecbK0iO0WAoQQN1P(bh);
      //appendnew_next_sd_0phqgyaL0xAdXHOi
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_0phqgyaL0xAdXHOi');
    }
  }

  async sd_ecbK0iO0WAoQQN1P(bh) {
    try {
      if (
        this.sdService.operators['null'](
          this.page.fetchRes,
          undefined,
          undefined,
          undefined
        )
      ) {
        bh = this.sd_nYetRh9WVxYREO0i(bh);
      } else {
        bh = await this.sd_r63gCZ86q5HLuml4(bh);
      }

      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_ecbK0iO0WAoQQN1P');
    }
  }

  sd_r63gCZ86q5HLuml4(bh) {
    try {
      const page = this.page;
      page.steps = page.fetchRes.logs;
      page.currentStep = 0;
      page.completedSteps = [];
      page.isProcessing = true;
      page.reportNames = page.fetchRes?.report?.map((item) => item.reportName);
      bh = this.sd_Fuc8QVkwUiivDxqc(bh);
      //appendnew_next_sd_r63gCZ86q5HLuml4
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_r63gCZ86q5HLuml4');
    }
  }

  sd_Fuc8QVkwUiivDxqc(bh) {
    try {
      let outputVariables = this.runSteps();

      //appendnew_next_sd_Fuc8QVkwUiivDxqc
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_Fuc8QVkwUiivDxqc');
    }
  }

  async sd_nYetRh9WVxYREO0i(bh) {
    try {
      const { paramObj: qprm, path: path } =
        this.sdService.getPathAndQParamsObj('/home/get-details');
      await this.__page_injector__
        .get(Router)
        .navigate([this.sdService.formatPathWithParams(path, undefined)], {
          queryParams: Object.assign(qprm, ''),
        });
      //appendnew_next_sd_nYetRh9WVxYREO0i
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_nYetRh9WVxYREO0i');
    }
  }

  sd_BT8JjszJYtpBWyed(bh) {
    try {
      const page = this.page;
      if (page.currentStep < page.steps.length) {
        setTimeout(() => {
          page.completedSteps.push(page.currentStep);
          page.currentStep++;
          this.runSteps();
        }, 1000);
      } else {
        setTimeout(() => {
          page.isProcessing = false;
        }, 1000);
      }

      setTimeout(() => {
        if (this.logComponent) {
          const container = this.logComponent.nativeElement;
          container.scrollTo({
            top: container.scrollHeight,
            behavior: 'smooth',
          });
        }
      }, 1001);
      //appendnew_next_sd_BT8JjszJYtpBWyed
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_BT8JjszJYtpBWyed');
    }
  }

  sd_POZQMCLgfnsMV06s(bh) {
    try {
      const page = this.page;
      if (page.completedSteps.includes(bh.input.index)) {
        bh.local.className = 'completed';
      } else if (bh.input.index === page.currentStep) {
        bh.local.className = 'processing';
      } else {
        bh.local.className = 'pending';
      }

      //appendnew_next_sd_POZQMCLgfnsMV06s
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_POZQMCLgfnsMV06s');
    }
  }

  sd_BGINIFTw2vJCjFsA(bh) {
    try {
      bh.pageViews = Object.assign(bh.pageViews || {}, {
        logComponent: this.logComponent,
      });
      //appendnew_next_sd_BGINIFTw2vJCjFsA
      return bh;
    } catch (e) {
      return this.errorHandler(bh, e, 'sd_BGINIFTw2vJCjFsA');
    }
  }

  //appendnew_node

  ngOnDestroy() {
    const bh: any = this.__page_injector__
      .get(SDPageCommonService)
      .constructFlowObject(this);
    this.__page_injector__.get(SDPageCommonService).deletePageFromMap(this);
  }

  // error_handler_slot
  private errorHandler(bh, e, src): Promise<any> {
    console.error(e);
    bh.error = e;
    bh.errorSource = src;
    throw e;
  }
  //appendnew_flow_processLogComponent_Catch
}
